import { render, staticRenderFns } from "./CourseReviews.vue?vue&type=template&id=2b36c594&scoped=true"
import script from "./CourseReviews.vue?vue&type=script&lang=js"
export * from "./CourseReviews.vue?vue&type=script&lang=js"
import style0 from "./CourseReviews.vue?vue&type=style&index=0&id=2b36c594&prod&scoped=true&lang=css"
import style1 from "./CourseReviews.vue?vue&type=style&index=1&id=2b36c594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36c594",
  null
  
)

export default component.exports